<template>
  <div class="ilan-report-container">
    <img class="bg-image" src="/static/images/ilan/bg2.png" />
    <img class="bg-logo" src="/static/images/ilan/bg-logo.png" />
    <img class="logo" src="/static/images/ilan/logo.png" />
    <img class="daji-image" src="/static/images/ilan/daji.png" />

    <div class="white-card">
      <div class="card-header">
        <span class="header-title">信息填写</span>
      </div>
      <div class="card-header-tip">
        <span class="header-tip">（请填写真实有效的信息）</span>
      </div>
      <div class="form-container">
        <div class="form-item">
          <div class="form-label"><span class="required">*</span>举报对象</div>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" v-model="reportType" name="reportType" value="online" />
              <span class="radio-text">线上渠道</span>
            </label>
            <label class="radio-label">
              <input type="radio" v-model="reportType" name="reportType" value="offline" />
              <span class="radio-text">线下渠道</span>
            </label>
          </div>
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label"><span class="required">*</span>举报店铺</div>
          <input type="text" v-model="reportShop" class="form-input" placeholder="请输入举报店铺" />
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label"><span class="required">*</span>举报链接</div>
          <input type="text" v-model="reportLink" class="form-input" placeholder="请输入举报链接" />
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label"><span class="required">*</span>购买平台</div>
          <input type="text" v-model="purchasePlatform" class="form-input" placeholder="请输入购买平台" />
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label"><span class="required">*</span>产品信息</div>
          <textarea v-model="productInfo" class="form-textarea" placeholder="请输入产品信息"></textarea>
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label"><span class="required">*</span>手机号</div>
          <input type="tel" v-model="phone" class="form-input" placeholder="请输入手机号" />
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label">淘宝账号</div>
          <input type="text" v-model="taobaoAccount" class="form-input" placeholder="请输入淘宝账号" />
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label">微信号</div>
          <input type="text" v-model="wechatAccount" class="form-input" placeholder="请输入微信号" />
        </div>

        <div class="divider"></div>

        <div class="form-item">
          <div class="form-label"><span class="required">*</span>上传凭证</div>
          <input type="file" ref="fileInput" accept="image/*" multiple @change="handleFileChange" style="display: none;" />
          <div class="upload-area">
            <div class="upload-btn" @click="triggerFileInput">
            <span class="upload-icon">+</span>
            <span class="upload-text">选择图片</span>
          </div>
          <div class="upload-preview" v-if="uploadedFiles.length > 0">
            <div class="preview-item" v-for="(file, index) in uploadedFiles" :key="index">
              <img class="preview-image" :src="getObjectURL(file)" />
              <div class="preview-delete" @click="deleteFile(index)">×</div>
          </div>
        </div>
      </div>
      <div class="upload-tip">最多上传3张图片</div>
    </div>
  </div>
</div>

<div class="submit-btn" @click="handleSubmit">提交</div>

<div v-show="isShow" class="loading-mask">
<div class="loading-content">
  <div class="loading-spinner"></div>
  <div class="loading-text">提交中...</div>
</div>
</div>
        </div>
        </template>

<script>
import { submitIlanReport } from '../../api/api'

export default {
  name: 'ILanReport',
  data() {
    return {
      code: '',
      reportType: '',
      reportShop: '',
      reportLink: '',
      purchasePlatform: '',
      productInfo: '',
      phone: '',
      taobaoAccount: '',
      wechatAccount: '',
      uploadedFiles: [],
      isSubmitting: false,
      isShow: false
    }
  },
  mounted() {
    this.code = this.$route.query.c || ''
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      const files = event.target.files
      if (!files || files.length === 0) return

      const remainingSlots = 3 - this.uploadedFiles.length
      const filesToUpload = Array.from(files).slice(0, remainingSlots)

      filesToUpload.forEach(file => {
        if (!file.type.startsWith('image/')) {
          alert('请选择图片文件')
          return
        }
        if (file.size > 5 * 1024 * 1024) {
          alert('图片大小不能超过5MB')
          return
        }
        this.uploadedFiles.push(file)
      })

      event.target.value = ''
    },
    deleteFile(index) {
      this.uploadedFiles.splice(index, 1)
    },
    getObjectURL(file) {
      return URL.createObjectURL(file)
    },
    validatePhone(phone) {
      const phoneReg = /^1\d{10}$/
      return phoneReg.test(phone)
    },
    validateForm() {
      if (!this.reportType) {
        alert('请选择举报对象')
        return false
      }
      if (!this.reportShop.trim()) {
        alert('请输入举报店铺')
        return false
      }
      if (!this.reportLink.trim()) {
        alert('请输入举报链接')
        return false
      }
      if (!this.purchasePlatform.trim()) {
        alert('请输入购买平台')
        return false
      }
      if (!this.productInfo.trim()) {
        alert('请输入产品信息')
        return false
      }
      if (!this.phone.trim()) {
        alert('请输入手机号')
        return false
      }
      if (!this.validatePhone(this.phone.trim())) {
        alert('请输入正确的手机号')
        return false
      }
      if (this.uploadedFiles.length === 0) {
        alert('请上传凭证')
        return false
      }
      return true
    },
    async handleSubmit() {
      if (this.isSubmitting) {
        return
      }

      if (!this.validateForm()) {
        return
      }

      this.isSubmitting = true
      this.isShow = true

      const formData = new FormData()
      formData.append('code', this.code)
      formData.append('reportType', this.reportType)
      formData.append('reportShop', this.reportShop.trim())
      formData.append('reportLink', this.reportLink.trim())
      formData.append('purchasePlatform', this.purchasePlatform.trim())
      formData.append('productInfo', this.productInfo.trim())
      formData.append('phone', this.phone.trim())
      formData.append('taobaoAccount', this.taobaoAccount.trim())
      formData.append('wechatAccount', this.wechatAccount.trim())

      this.uploadedFiles.forEach((file) => {
        formData.append('evidenceFiles', file)
      })

      try {
        const response = await submitIlanReport(formData)
        if (response.data.code === 200) {
          alert('举报提交成功')
          this.$router.push('/ilan')
          //this.resetForm()
        } else {
          alert(response.data.msg || '提交失败，请重试')
        }
      } catch (error) {
        console.error('提交举报失败:', error)
        alert('系统异常，请稍后重试')
      } finally {
        this.isSubmitting = false
        this.isShow = false
      }
    },
    // resetForm() {
    //   this.reportType = ''
    //   this.reportShop = ''
    //   this.reportLink = ''
    //   this.purchasePlatform = ''
    //   this.productInfo = ''
    //   this.phone = ''
    //   this.taobaoAccount = ''
    //   this.wechatAccount = ''
    //   this.uploadedFiles = []
    // }
  }
}
</script>

<style scoped>
.ilan-report-container {
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.bg-logo {
  position: absolute;
  top: 8vh;
  left: 50%;
  width: 80vw;
  transform: translateX(-50%);
  z-index: 2;
}

.logo {
  position: absolute;
  top: 11vh;
  left: 50%;
  width: 33vw;
  transform: translateX(-50%);
  z-index: 3;
}

.daji-image {
  position: absolute;
  top: 20vh;
  left: 50%;
  width: 36vw;
  transform: translateX(-50%);
  z-index: 2;
}

.info-image {
  position: absolute;
  top: 32vh;
  left: 50%;
  width: 25vw;
  transform: translateX(-50%);
  z-index: 2;
}

.white-card {
  position: absolute;
  top: 30vh;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
  height: 56vh;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 25px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3vh 0 2vh 0;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5vw;
  margin-bottom: 1vh;
  flex-shrink: 0;
}

.header-title {
  color: black;
  font-size: 4.5vw;
  font-weight: bold;
}

.card-header-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5vw;
  margin-bottom: 2vh;
  flex-shrink: 0;
}

.header-tip {
  color: rgb(150, 150, 150);
  font-size: 3vw;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 0vw;
}

.form-container {
  width: 100%;
  padding: 0 5vw;
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 1.5vh;
  padding: 2vh 0;
}

.form-label {
  color: rgb(60, 60, 60);
  font-size: 3.5vw;
  font-weight: 500;
}

.required {
  color: rgb(179, 0, 0);
  margin-right: 0.5vw;
}

.radio-group {
  display: flex;
  gap: 4vw;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 1vw;
  cursor: pointer;
}

.radio-label input[type="radio"] {
  width: 4vw;
  height: 4vw;
  accent-color: rgb(1, 63, 179);
}

.radio-text {
  color: rgb(60, 60, 60);
  font-size: 3.5vw;
}

.form-input {
  width: 100%;
  padding: 2vh 3vw;
  border: 1px solid rgb(200, 200, 200);
  border-radius: 8px;
  font-size: 3.5vw;
  color: rgb(60, 60, 60);
  box-sizing: border-box;
  outline: none;
}

.form-input:focus {
  border-color: rgb(1, 63, 179);
}

.form-input::placeholder {
  color: rgb(180, 180, 180);
}

.form-textarea {
  width: 100%;
  padding: 2vh 3vw;
  border: 1px solid rgb(200, 200, 200);
  border-radius: 8px;
  font-size: 3.5vw;
  color: rgb(60, 60, 60);
  box-sizing: border-box;
  outline: none;
  min-height: 15vh;
  resize: none;
}

.form-textarea:focus {
  border-color: rgb(1, 63, 179);
}

.form-textarea::placeholder {
  color: rgb(180, 180, 180);
}

.divider {
  width: 100%;
  height: 1px;
  background-color: rgb(230, 230, 230);
}

.upload-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25vw;
  height: 25vw;
  border: 2px dashed rgb(200, 200, 200);
  border-radius: 12px;
  background-color: rgb(250, 250, 250);
  cursor: pointer;
  gap: 1vh;
}

.upload-area {
  display: flex;
  flex-direction: column;
  gap: 1vh;
  width: 100%;
}

.upload-preview {
  display: flex;
  gap: 1.5vw;
  flex-wrap: wrap;
  margin-top: 1vh;
}

.preview-item {
  position: relative;
  width: 20vw;
  height: 20vw;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.preview-delete {
  position: absolute;
  top: -1vh;
  right: -1vw;
  width: 5vw;
  height: 5vw;
  background-color: rgb(179, 0, 0);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4vw;
  cursor: pointer;
  line-height: 1;
}

.upload-tip {
  color: rgb(150, 150, 150);
  font-size: 2.5vw;
  margin-top: 1vh;
}

.upload-icon {
  font-size: 8vw;
  color: rgb(180, 180, 180);
  font-weight: 300;
  line-height: 1;
}

.upload-text {
  color: rgb(150, 150, 150);
  font-size: 3vw;
}

.submit-btn {
  position: absolute;
  bottom: 5vh;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgb(1, 63, 179);
  color: white;
  font-size: 4vw;
  padding: 2vh 5vw;
  border-radius: 25px;
  cursor: pointer;
  width: 90vw;
  text-align: center;
  font-weight: 500;
  z-index: 3;
}

.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2vh;
}

.loading-spinner {
  width: 10vw;
  height: 10vw;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: rgb(1, 63, 179);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: white;
  font-size: 4vw;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/ILan/Report.vue